import { onMounted, onUnmounted, ref } from 'vue'

export function useNetworkStatus() {
  const isOnline = ref(navigator.onLine)
  const showOfflineModal = ref(false)

  function handleOnline() {
    isOnline.value = true
    showOfflineModal.value = false
    setTimeout(() => {
      showOfflineModal.value = false
    }, 1_000)
  }

  function handleOffline() {
    isOnline.value = false
    showOfflineModal.value = true
  }

  onMounted(() => {
    window.addEventListener('online', handleOnline)
    window.addEventListener('offline', handleOffline)

    // Development helper - expose test function to window
    if (import.meta.env.DEV) {
      window.testNetworkDisconnect = () => {
        handleOffline()
      }
      window.testNetworkConnect = () => {
        handleOnline()
      }
    }
  })

  onUnmounted(() => {
    window.removeEventListener('online', handleOnline)
    window.removeEventListener('offline', handleOffline)

    // Clean up development helpers
    if (import.meta.env.DEV) {
      delete window.testNetworkDisconnect
      delete window.testNetworkConnect
    }
  })

  function hideOfflineModal() {
    showOfflineModal.value = false
  }

  return {
    isOnline,
    showOfflineModal,
    hideOfflineModal,
  }
}
